import { FC } from 'react';

import SweetenerSystemListing from 'components/main/SweetenerSystem';

const SweetenerSystem: FC = () => <SweetenerSystemListing />;

export default SweetenerSystem;
